import { useCameraDetails } from '@hakimo-ui/hakimo/data-access';
import { LiveViewSwitch } from '@hakimo-ui/hakimo/feature-shared';
import { DoorCameraResponse } from '@hakimo-ui/hakimo/types';
import { QueryResult } from '@hakimo-ui/hakimo/ui-elements';

interface Props {
  cameraId: string;
  doorCameraDetails?: Pick<DoorCameraResponse, 'cameraId' | 'livestreamUrl'>;
}

export function LiveView(props: Props) {
  const { cameraId, doorCameraDetails } = props;
  const cameraQueryResult = useCameraDetails(
    cameraId,
    undefined,
    !doorCameraDetails
  );

  if (doorCameraDetails) {
    return (
      <LiveViewSwitch
        cameraId={doorCameraDetails.cameraId}
        livestreamUrl={doorCameraDetails.livestreamUrl}
      />
    );
  }
  return (
    <QueryResult queryResult={cameraQueryResult}>
      {(data) => {
        return (
          <LiveViewSwitch
            cameraId={data.id}
            livestreamUrl={data.livestreamUrl}
          />
        );
      }}
    </QueryResult>
  );
}
